"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/fn/promise");

require("core-js/fn/array/includes");

var _Component = _interopRequireDefault(require("./Component"));

var _limiter = _interopRequireDefault(require("./limiter"));

// Available to all components
require('core-js/modules/es6.object.assign');
/**
 * Internal class for instantiating the Module Manager
 */


var ComponentManager = /*#__PURE__*/function () {
  /**
   * Start the component manager
   *
   * @param {string} manifest - arbitrary string corresponding to an object on `window` that we'll use to track configuration and instances of each component.
   *                            This generally corresponds to the WP theme name (`wp-starter-theme` for example)
   */
  function ComponentManager(manifest) {
    (0, _classCallCheck2.default)(this, ComponentManager);
    var manifestDefaults = {
      components: {}
    }; // Set up "singleton" manifest containing references to
    // all component instances and elements they're attached to

    window[manifest] = window[manifest] ? window[manifest] : manifestDefaults; // Set up limiter to prevent race conditions in reads/writes to manifest

    window.jsComponentFrameworkLimiter = window.jsComponentFrameworkLimiter ? window.jsComponentFrameworkLimiter : _limiter.default;
    this.manifest = window[manifest];
    this.limiter = window.jsComponentFrameworkLimiter;
  }
  /**
   * Loop through component elements and instantiate the component for each
   *
   * @param {object|array} configs - config or configs corresponding to components you want to instance
   * @param {HTMLElement} context - context on which to initalize components, default is `document`
   */


  (0, _createClass2.default)(ComponentManager, [{
    key: "initComponents",
    value: function initComponents(configs) {
      var _this = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
      var componentConfigs = Array.isArray(configs) ? configs : [configs];
      componentConfigs.forEach(this.limiter(function (config) {
        return _this.initComponent(config, context);
      }, 500));
    }
  }, {
    key: "initComponent",
    value: function initComponent(componentConfig, context) {
      var _this2 = this;

      var componentName = componentConfig.name;
      var ComponentClass = componentConfig.class; // Check if component is configured and extends the core Component class

      if (ComponentClass.prototype instanceof _Component.default) {
        var hasComponent = Object.keys(this.manifest.components).includes(componentName);
        var componentEls = context.querySelectorAll("[data-component='".concat(componentName, "']")); // Can't find any elements!

        if (!componentEls.length) {
          /* eslint-disable no-console, max-len */
          console.info("No elements found for data-component=\"".concat(componentName, "\""));
          /* eslint-enable */

          return;
        } // Add component to manifest if it doesn't exist already


        if (!hasComponent) {
          this.manifest.components[componentName] = {
            config: componentConfig,
            instances: []
          };
        } // Loop through elements and add instance for each


        Array.prototype.forEach.call(componentEls, function (element) {
          // Skip this element if we've already instantiated a component on it
          var exists = _this2.manifest.components[componentName].instances.some(function (instance) {
            return element.isSameNode(instance.element);
          });

          if (exists) {
            return;
          } // Create and start instance


          componentConfig.element = element;
          var instance = new ComponentClass(componentConfig); // add instance to manifest

          _this2.manifest.components[componentName].instances.push({
            instance: instance,
            element: element
          });
        });
      }
    }
    /**
     * Loop through and restart components (use, for example, if you've removed and re-added components from the DOM and need the JS started again)
     *
     * @param {string} componentName - name of component to instantiate
     * @param {HTMLElement} context - context on which to initalize components, default is entire document
     */

  }, {
    key: "reinitComponent",
    value: function reinitComponent(componentName, context) {
      var componentConfig = this.manifest.components[componentName].config;

      if (componentConfig) {
        this.initComponents([componentConfig], context);
      }
    }
    /**
     * Call a method of a component from a different component
     *
     * @param {string} componentName - Name of component that has target function
     * @param {function} method - Component method you want to call
     * @param {array} args - Array of arguments to pass to component method
     */

  }], [{
    key: "callComponentMethod",
    value: function callComponentMethod(componentName, method) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      // Does the component exist?
      if (this.manifest[componentName] && this.manifest[componentName].instances) {
        this.manifest[componentName].instances.forEach(function (instance) {
          // Use JS .call to call the component method with proper context
          if ('function' === typeof instance[method]) {
            var _instance$method;

            (_instance$method = instance[method]).call.apply(_instance$method, [instance].concat((0, _toConsumableArray2.default)(args)));
          }
        });
      }
    }
  }]);
  return ComponentManager;
}();

exports.default = ComponentManager;